import React from 'react'
import { Button, Container, Row, Col } from 'react-bootstrap'
import { trackUploadFileCount } from 'utils/sendy'
import * as Sentry from '@sentry/react'

import './SuccessBox.css'

const SuccessBox = ({ userProfile, site, files, onClose, onReset }) => {
  if (!site) {
    Sentry.captureException(
      { userProfile, site, files, onClose, onReset },
      {
        tags: {
          section: 'load-site-error'
        }
      }
    )
  }

  const siteUrl = site?.subdomain || ''
  const transferRequestUrl = `https://${siteUrl}`

  const trialAccount = !userProfile.productId

  const handleClose = () => {
    onClose()
    trackUploadFileCount()
  }

  return (
    <Container fluid>
      <Row className={trialAccount ? 'flex-column-reverse flex-lg-row' : ''}>
        <Col lg={trialAccount ? 7 : 12} className={`p-4 bg-white ${trialAccount ? 'rounded-end' : 'rounded-2'}`}>
          <div className="success-box">
            <div className="float-right" onClick={handleClose}>
              <img className="exit" src="/delete.png" alt="quit" />
            </div>
            <h3 className="bold">Success</h3>
            <img className="celebrate" src="/celebrate.gif" alt="celebrate" />
            <div>
              <div className="dark-grey-2">Your shared project is now live</div>
              <h5 className="domain d-flex align-items-center justify-content-center bold">
                <a href={transferRequestUrl} target="_blank" rel="noreferrer" data-testid="SuccessBoxHomePage-a-domain">
                  {siteUrl}
                </a>
              </h5>
              <div className="d-flex flex-column mt-3 align-items-center">
                <div className="mt-1 d-flex align-items-center flex-row">
                  <Button
                    className="custom-button"
                    variant="light"
                    onClick={() => navigator.clipboard.writeText(transferRequestUrl)}
                  >
                    <img height="16" width="16px" src="/assets/icons/link.svg" className="me-1" alt="Copy link" />
                    Copy link
                  </Button>
                  <Button className="ms-2" onClick={() => window.open(transferRequestUrl, '_blank')} variant="primary">
                    View Project
                  </Button>
                </div>
                <div className="border border-black p-3 mt-4 round-16">
                  <p className="font-20 bold mb-2 text-start flex align-items-center dark-grey-2">
                    <img src="/assets/icons/info-grey.svg" height={18} className="me-2" />
                    Shared Projects
                  </p>
                  <div className="mb-3 text-start grey">
                    When someone visits this link, they can upload new files to this project. You will be notified
                    whenever someone uploads a new file.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default SuccessBox
